// export const myVar = 'This is my variable'
export const settings = {
  jsonUrl: 'https://graphicinvention.nl/wp-json/',
  baseUrl: 'https://graphicinvention.nl/',
  plyrDefault: {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'airplay', 'fullscreen']
  }
}
